import { Navigate } from "react-router-dom";
import { useAuthentication } from "../contexts/AuthenticationContext";

export function AuthenticatedGuard({ children }: { children: JSX.Element }) {
  const [{ isAuthenticated }] = useAuthentication();

  if (!isAuthenticated) {
    sessionStorage.setItem("__redirect_after_login__", window.location.pathname);
    return <Navigate to="/auth/sign-in" />;
  }

  return children;
}
